import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './StoringenOverzicht.css';
import api from '../services/api';

const TYPE_META = {
  klantmelding: { label: '\ud83d\udce3 Klantmelding' },
  werkorder: { label: '🛠️ Opdracht' },
  restwerk:  { label: '📋 Restwerk' },
  gevaar:    { label: '⚠️ Gevaarlijke situatie' },
  materiaal: { label: '📦 Materiaal' },
  idee:      { label: '💡 Opmerking' },
};

const Meldingen = () => {
  const navigate = useNavigate();
  const [meldingen, setMeldingen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('alle');

  useEffect(() => { loadMeldingen(); }, []);

  const loadMeldingen = async () => {
    try {
      const response = await api.get('/meldingen');
      setMeldingen(response.data.meldingen || []);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden meldingen:', error);
      setLoading(false);
    }
  };

  const getPrioriteitColor = (p) => {
    switch (p) {
      case 'urgent': return '#ef4444';
      case 'hoog': return '#f59e0b';
      case 'normaal': return '#3b82f6';
      case 'laag': return '#10b981';
      default: return '#6b7280';
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      nieuw: { label: 'Nieuw', color: '#ef4444' },
      doorgestuurd: { label: 'Doorgestuurd', color: '#EF9F27' },
      in_behandeling: { label: 'In behandeling', color: '#3b82f6' },
      ingepland: { label: 'Ingepland', color: '#3b82f6' },
      opgelost: { label: 'Opgelost', color: '#10b981' },
      afgehandeld: { label: 'Afgehandeld', color: '#10b981' },
      afgewezen: { label: 'Afgewezen', color: '#6b7280' },
    };
    const badge = badges[status] || { label: status, color: '#6b7280' };
    return (
      <span style={{ background: badge.color, color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: '600' }}>
        {badge.label}
      </span>
    );
  };

  const TABS = [
    ['alle', 'Alle'],
    ['doorgestuurd', 'Doorgestuurd'],
    ['werkorder', 'Opdracht'],
    ['restwerk', 'Restwerk'],
    ['gevaar', 'Gevaarlijk'],
    ['materiaal', 'Materiaal'],
    ['idee', 'Opmerking'],
    ['klantmelding', 'Klant'],
  ];
  const tabCount = (v) => v === 'alle' ? meldingen.length
    : v === 'doorgestuurd' ? meldingen.filter(m => m.doorgestuurd_naar_afdeling).length
    : meldingen.filter(m => m.type === v).length;
  const filtered = activeTab === 'alle' ? meldingen
    : activeTab === 'doorgestuurd' ? meldingen.filter(m => m.doorgestuurd_naar_afdeling)
    : meldingen.filter(m => m.type === activeTab);

  if (loading) return <div className="loading-screen">Laden...</div>;

  return (
    <div className="storingen-overzicht">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>📣 Meldingen</h1>
          <div className="header-actions"></div>
        </div>

        <div className="storingen-tabs" style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
          {TABS.map(([v, l]) => (
            <button key={v} onClick={() => setActiveTab(v)} style={{
              padding: '10px 20px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: '600',
              background: activeTab === v ? '#3b82f6' : '#e5e7eb', color: activeTab === v ? 'white' : '#374151'
            }}>
              {l} ({tabCount(v)})
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="no-storingen"><p>Geen meldingen</p></div>
        ) : (
          <div className="storingen-list">
            {filtered.map(m => (
              <div key={m.id} className="storing-card" onClick={() => navigate(`/melding/${m.id}`)}>
                <div className="storing-header">
                  <div className="storing-title">
                    <div className="prioriteit-dot" style={{ background: getPrioriteitColor(m.prioriteit) }} />
                    <h3>{m.titel}</h3>
                  </div>
                  {getStatusBadge(m.status)}
                </div>
                <p className="storing-beschrijving">
                  {(TYPE_META[m.type]?.label || m.type)}{m.beschrijving ? ' — ' + m.beschrijving : ''}
                </p>
                <div className="storing-meta">
                  {m.object_naam && <span>{m.object_naam}</span>}
                  <span>👤 {m.gemeld_door_voornaam} {m.gemeld_door_achternaam}</span>
                  {m.locatie_adres && <span>📍 {m.locatie_adres}</span>}
                  {m.aantal_fotos > 0 && <span>📷 {m.aantal_fotos} foto's</span>}
                  {m.doorgestuurd_afdeling_naam && <span>➡️ {m.doorgestuurd_afdeling_naam}</span>}
                  {m.werkorder_id && <span>🛠️ WO #{m.werkorder_id}</span>}
                  <span>🕐 {new Date(m.created_at).toLocaleString('nl-NL')}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Meldingen;
